const userDetailsReducer = (state={items:[]},action)=>{
    switch (action.type) {
        case 'USER_DATA':

            return {
                items:  action.payload,
            };
        default:
            return state;

    }
}
export default userDetailsReducer;